var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9131 46.4004H25.6087",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4131 44.6718L35.8824 43.2024C36.381 42.7043 37.1089 42.5127 37.7881 42.7011C38.4673 42.8894 38.9927 43.4284 39.1635 44.1122L39.3044 44.6718L40.9048 43.6055C41.6809 43.088 42.7144 43.1903 43.3739 43.85L44.1957 44.6718H48.1087",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 40.7578H21.7035",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5597 17.0625L38.7115 21.2142",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8305 11.1143L44.6606 11.9444C45.5774 12.8613 45.5774 14.3479 44.6605 15.2647L27.6435 32.2811L23.4932 28.1306L40.5102 11.1142C41.4271 10.1974 42.9136 10.1974 43.8305 11.1143V11.1143Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4919 28.1309L20.7253 35.0491L27.6436 32.2826",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2446 11.5298L46.7744 9",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7391 25.1064H8.97826C8.43798 25.1064 8 25.5444 8 26.0847V49.563C8 50.1032 8.43798 50.5412 8.97826 50.5412H52.0217C52.562 50.5412 53 50.1032 53 49.563V26.0847C53 25.5444 52.562 25.1064 52.0217 25.1064H42.2391",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3123 31.4756C39.3123 31.1994 39.5361 30.9756 39.8123 30.9756H46.6383C46.9145 30.9756 47.1383 31.1994 47.1383 31.4756V36.3452C47.1383 36.6213 46.9145 36.8452 46.6383 36.8452H39.8123C39.5361 36.8452 39.3123 36.6213 39.3123 36.3452V31.4756Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8071 11.8158L38.2419 10.2506C37.4779 9.48679 36.2394 9.48679 35.4754 10.2506L31.4782 14.2556",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContract);
export default __webpack_public_path__ + "static/media/icon-contract.ddb4fbdd.svg";
export { ForwardRef as ReactComponent };